import React, { useState, useMemo } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { useSetRecoilState } from 'recoil';
import { messageState } from '../../atoms/';
import { makeRequest } from '../../Utils';

const initialOptions = {
  'client-id':
    window.location.hostname === 'localhost'
      ? 'AQmcKx7tI4OKNz7H2ZgNKIOgg99auNnjHjBjVVers_uLCvdScCXGnH-PnDjcHfsOzRVotfeV_8BCTjEq'
      : 'Aa6SIRAa-23b2quudJVQajy0wNZ2jUX-XEyL3-FzKPn5Q47JnX4FqkTcRgwD_xO8QjvRMITZLhKzGli2',
  'enable-funding': 'venmo',
  'disable-funding': 'card',
  'data-sdk-integration-source': 'integrationbuilder_sc',
};

export default function PayPal({
  setUploading,
  checkout,
  sessionId,
  disabled,
  items,
  shipping,
  total,
  address,
}) {
  const [orderId, setOrderId] = useState(null);
  const amountValue = useMemo(() => total, [total]);
  const setMessage = useSetRecoilState(messageState);

  return (
    <div className="payPalButtons">
      <PayPalScriptProvider options={initialOptions}>

        {/* 
          ⭐ PayPal cannot handle enable/disable lifecycle.
          We conditionally render instead of toggling disabled state.
        */}
        {!disabled && (
          <PayPalButtons
            style={{ shape: 'rect', layout: 'vertical' }}

            // ⭐ Only re-render when the amount changes
            forceReRender={[amountValue]}

            createOrder={async () => {
              try {
                setUploading(true);

                const orderData = await makeRequest('paypal-order', 'POST', {
                  items,
                  shipping,
                  total,
                  address,
                });

                if (!orderData?.id) {
                  const detail = orderData?.details?.[0];
                  const message = detail
                    ? `${detail.issue} ${detail.description} (${orderData.debug_id})`
                    : JSON.stringify(orderData);
                  throw new Error(message);
                }

                setOrderId(orderData.id);
                return orderData.id;
              } catch (error) {
                console.error(error);
                setUploading(false);
                setMessage({
                  type: 'error',
                  label: 'Oops!',
                  text: `Could not initiate PayPal Checkout...${error}`,
                  temp: true,
                });
                throw error; // ⭐ REQUIRED
              }
            }}

            onApprove={async (data, actions) => {
              try {
                const requestId = sessionId; // This is used to idempotently retry requests

                const orderData = await makeRequest(
                  `paypal-capture?id=${data.orderID}&requestId=${requestId}`,
                  'POST'
                );

                const detail = orderData?.details?.[0];

                if (detail?.issue === 'INSTRUMENT_DECLINED') {
                  return actions.restart();
                }

                if (detail) {
                  throw new Error(`${detail.description} (${orderData.debug_id})`);
                }

                setOrderId(orderData.id);
                checkout(orderData.id, orderData);
              } catch (error) {
                console.error(error);
                setUploading(false);
                setMessage({
                  type: 'error',
                  label: 'Oops!',
                  text: `Sorry, your transaction could not be processed...${error}`,
                  temp: true,
                });
                throw error; // ⭐ REQUIRED
              }
            }}

            onCancel={() => {
              setUploading(false);
            }}
          />
        )}
      </PayPalScriptProvider>
    </div>
  );
}